import { configureStore } from '@reduxjs/toolkit';
import { isProd } from 'students/constants';
import rootReducer from 'students/stores/rootReducer';

export const mockStore = configureStore({
  reducer: rootReducer,
  devTools: !isProd
});
